import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#171717",
      "fill-rule": "evenodd",
      d: "M3.75 9h1.5v6h-1.5zm1.5-.75h-1.5A.75.75 0 0 0 3 9v6c0 .414.336.75.75.75h1.5A.75.75 0 0 0 6 15V9a.75.75 0 0 0-.75-.75M8.25 3h1.5v12h-1.5zm1.5-.75h-1.5A.75.75 0 0 0 7.5 3v12c0 .414.336.75.75.75h1.5a.75.75 0 0 0 .75-.75V3a.75.75 0 0 0-.75-.75M12.75 6h1.5v9h-1.5zm1.5-.75h-1.5A.75.75 0 0 0 12 6v9c0 .414.336.75.75.75h1.5A.75.75 0 0 0 15 15V6a.75.75 0 0 0-.75-.75",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }